/* eslint-disable @typescript-eslint/no-explicit-any */
// Disallow/re-allow dropping of arbitrary files/links

function cancelEvent(event: { [key: string]: any }) {
  event.preventDefault();
}

function disallow() {
  window.addEventListener('dragover', cancelEvent);
  window.addEventListener('drop', cancelEvent);
}

function allow() {
  window.removeEventListener('dragover', cancelEvent);
  window.removeEventListener('drop', cancelEvent);
}

let DocumentDragDrop = { allow, disallow };

export default DocumentDragDrop;
